<div *ngIf="data" class="zen-toast">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center text-start">
            <i class="material-symbols-rounded">{{ data.icon }}</i>
            <span class="text-md ms-2">{{ data.message }}</span>
        </div>
        <i class="material-symbols-rounded pointer" (click)="snackBarRef.dismiss()">close</i>
    </div>
</div>
